import {
  DELETE_PLC_SAFETY_TRIGGER,
  DELETE_PLC_SAFETY_TRIGGER_SUCCESSFUL,
  DELETE_PLC_SAFETY_TRIGGER_FAILED,
} from './actionTypes';

export const deletePlcSafetyTrigger = (trigger) => ({
  type: DELETE_PLC_SAFETY_TRIGGER,
  payload: { trigger },
});

export const deletePlcSafetyTriggerSuccessful = (message) => ({
  type: DELETE_PLC_SAFETY_TRIGGER_SUCCESSFUL,
  payload: message,
});

export const deletePlcSafetyTriggerFailed = (message) => ({
  type: DELETE_PLC_SAFETY_TRIGGER_FAILED,
  payload: message,
});
